<template xmlns="http://www.w3.org/1999/html">

  <div class="index" style="height: 900px">
    <!--  页面顶部-->
    <div class="header" id="showSign">
      <!--点击报名-->
      <div class="elpopover">
        <el-dialog
            :width="450"
            trigger="click"
            v-model="sign1"
            :modal='false'
            :show-close="false"
            style=" --el-dialog-width: 450px;
    display: flex;
    margin-right: 124px;
    margin-top: 157px;
    background: rgba(0,0,0,0);
    height: 300px;
    align-items: center;
    justify-content: flex-end;"
        >
          <div class="login2">
            <div style="padding-top: 30px;padding-left: 20px">
              {{ this.$t('sign_up.q_1') }}
              <div>
                <el-radio v-model="this.sign.questionOne" :label="1">Yes</el-radio>
                <el-radio v-model="this.sign.questionOne" :label="0">No</el-radio>
              </div>
            </div>
            <div style="padding-top: 20px;padding-left: 20px">
              {{ $t('sign_up.q_2') }}
              <div>
                <el-radio v-model="this.sign.questionTwo" :label="1">Yes</el-radio>
                <el-radio v-model="this.sign.questionTwo" :label="0">No</el-radio>
              </div>
            </div>
            <div style="padding-top: 30px;padding-left: 20px">
              {{ this.$t('sign_up.q_3') }}
              <div>
                <el-radio v-model="this.sign.questionThree" :label="1">{{ this.$t('sign_up.q_3_yes') }}</el-radio>
                <el-radio v-model="this.sign.questionThree" :label="0">{{ this.$t('sign_up.q_3_no') }}</el-radio>
              </div>
              <div style="padding-top: 20px;padding-left: 120px">
                <el-button @click="open1()">{{ $t('sign_up.confirm') }}</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
        <el-button slot="reference"
                   style="float: right;height: 50px;width: 112px; color: #dcdfe6;margin-right: 0px;background: #1462ad"
                   @click.native="signUp()">{{ $t('sign_up.sign_up') }}
        </el-button>

        <!--        <template #reference>-->
        <!--        </template>-->
      </div>
      <!--      登录注册-->
      <div class="elpopover">
        <el-button style="float: right;height: 50px; color: #dcdfe6;margin-right: 0px;width: 112px;background: #1462ad"
                   @click="dialogVisible3 = true" v-if="isCommit==0">{{ this.$i18n.t('login.login_button') }}
        </el-button>
        <el-button style="float: right;height: 50px; color: #dcdfe6;margin-right: 0px;width: 112px;background: #1462ad"
                   v-if="isCommit==1" @click="logout">{{ this.$i18n.t('login.exit_login') }}
        </el-button>
      </div>
      <div class="elpopover">
        <el-button style="float: right;font-size:15px;color:#ffffff;height: 50px;margin-right: 10px;" type="text"
                   @click="exchangeLanguage( this.$t('lang'))">
          <!--          <el-icon><Switch /></el-icon>-->
          <div>{{ this.$i18n.t('lang') }}</div>
        </el-button>
      </div>
      <div class="logo_box">
        <!--        网站logo-->
        <div class="logo1">
          <img src="@/assets/logo3.png" alt="">
          <!--          <img width="271" height="77" src="https://www.ieeesmc.org/wp-content/uploads/2022/03/logo-smc.png" class="img-fluid" alt="IEEE SMC: Systems, Man, &amp;amp; Cybernetics Society" decoding="async" />-->
        </div>
        <div class="logo2">
          <img src="@/assets/logo-ieee-white.webp" alt="">
        </div>
        <div class="logo_title">
          <strong>{{ $t('title1') }}</strong><br/>
          <strong>{{ $t('title2') }}</strong>
        </div>
      </div>
    </div>


    <div class="tab-covered">
      <div class="tab_list">
        <div class="tab_item" :id="item.value" v-for="(item,index) in tab" :key="index" @click="aClick(item)">
          {{ $t(item.name) }}
        </div>
        <!--        <div class="tab_item" @click="j umpToBBS"  @mouseenter="ServiceEvaluation=true" @mouseleave="ServiceEvaluation=false">服务评价 ^</div>-->
        <div class="tab_item" @click="jumpToBBS">{{ $i18n.t('menus.forum') }}</div>
        <div class="tab_item" @click="jumpToSecondSession">{{ $i18n.t('menus.second') }}</div>
        <div class="tab_item" @click="jumpToFirstSession">{{ $i18n.t('menus.first') }}</div>
      </div>
    </div>
    <div class="content_index">
      <div class="router_view">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" class="router-view" ref="child">
          </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" class="router-view"  ref="child"></router-view>
      </div>
    </div>
    <div class="bottom_index">
      <div class="FriendLink">
        <ul>
          <li v-for="(item,index) in links" :key="item.id"><a :href="item.url" target="_blank">
            <el-button>{{ item.name }}</el-button>
          </a></li>
        </ul>
      </div>
      <div class="bottom">
        <!--      <span>©2022 AEE专家进高校</span><br> -->
        <span>技术支持单位：金陵科技学院 </span>
        <!--      <span><a class="a" href="http://www.qi-tech.com.cn/" target="_blank">北京奇观技术有限责任公司</a></span><br>-->
        <span>开发单位：南京雄君软件科技有限公司</span><br>
        <span><a class="a" href="https://beian.miit.gov.cn/" target="_blank">苏ICP备18033501号-5</a></span>
      </div>
    </div>
    <!--验证码
    captchaType：blockPuzzle滑块验证；clickWord点击文字验证-->
    <Verify @success="verifySuccess" mode="pop" captchaType="blockPuzzle" :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"></Verify>
  </div>
  <el-dialog v-model="dialogVisible3" width="40%">
    <div class="login_tab">
      <!--              <el-button style="align:right">X</el-button>-->
      <div class="login_tab_item1" @click="loginFlag = 1" ref="psswordLogin">{{ $t('login.password_login') }}</div>
      <div class="login_tab_item2" @click="loginFlag = 0" ref="register">{{ $t('login.register') }}</div>
    </div>

    <!--    登录界面-->
    <div v-show="loginFlag" style="margin-top:35px;text-align: center;font-size: 16px">
      <el-form-item :label="this.$t('login.phone_number')">
        <el-input v-model="loginForm.loginName" :placeholder="this.$t('login.phone_p')"/>
      </el-form-item>
      <el-form-item style="margin-bottom: 10px" :label="$t('login.password')">
        <el-input v-model="loginForm.password" :placeholder="this.$t('login.password_p')" show-password/>
      </el-form-item>
      <div class="remember">
        <el-checkbox v-model="remember">{{ $t('login.password_remember') }}</el-checkbox>
      </div>
      <el-button style="width: 200px;" type="primary" @click="loginVerify" class="login_button">{{ $t('login.login') }}</el-button>
    </div>

    <!--    注册界面-->
    <div v-show="!loginFlag" style="text-align: center;margin-top:30px;">
      <el-form-item :label="$t('login.phone_number')">
        <el-col>
          <el-input v-model="register.loginName" :placeholder="$t('login.phone_p')" clearable/>
        </el-col>
      </el-form-item>
      <el-form-item :label="this.$t('login.password')">
        <el-col>
          <el-input v-model="register.password1" :placeholder="$t('login.password_p')" show-password
                    clearable/>
        </el-col>
      </el-form-item>
      <el-form-item :label="this.$t('login.password')">
        <el-col>
          <el-input v-model="register.password2" :placeholder="$t('login.password_p_2')" show-password
                    clearable/>
        </el-col>
      </el-form-item>
      <el-button type="success" @click="mregister" style="margin-top:10px;width: 200px;">{{ $t('sign_up.confirm') }}</el-button>
    </div>
  </el-dialog>

  <!--  报名信息框-->
  <div>
    <el-dialog :title="$t('sign_up.registration_form')" v-model="this.commitFlag">
      <!--    <el-form :model="form">-->
      <div v-if="this.sign.comments!=null" style="font-weight: bold;font-size: 22px;margin-bottom: 10px">审批建议：{{this.sign.comments}}</div>
      <el-form>
        <el-row>
          <el-col :span="10">
            <el-form-item :label="$t('sign_up.first_name')">
              <el-input v-model="sign.firstName" autocomplete="off"
                        :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="padding-left: 30px">
            <el-form-item :label="$t('sign_up.last_name')">
              <el-input v-model="sign.lastName" autocomplete="off"
                        :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item :label="$t('sign_up.gender')">
              <el-radio v-model="sign.gender" label="m">{{ $t('sign_up.male') }}</el-radio>
              <el-radio v-model="sign.gender" label="f">{{ $t('sign_up.female') }}</el-radio>
              <el-radio v-model="sign.gender" label="n">{{ $t('sign_up.not_disclose') }}</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="padding-left: 30px">
            <el-form-item :label="$t('sign_up.nationality')">
              <el-input v-model="sign.nationality" autocomplete="off"
                        :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('sign_up.birth_date')" class="d">
          <el-date-picker
              v-model="sign.birthDate"
              type="date"
              :placeholder="$t('sign_up.choose_date')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('sign_up.affiliation')" class="d">
          <el-input v-model="sign.affiliation" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.position')" class="d">
          <el-input v-model="sign.position" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.research_interests')">
          <el-input v-model="sign.researchInterests" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.contact_address')">
          <el-input v-model="sign.contactAddress" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.telephone')">
          <el-input v-model="sign.telephone" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.email')">
          <el-input v-model="sign.email" autocomplete="off"
                    :placeholder="this.$i18n.t('sign_up.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('sign_up.identity')">
          <el-col :span="10">
            <el-radio class="el-radio__label1" v-model="sign.type" label="A">{{ $t('sign_up.identity1') }}</el-radio>
            <el-radio class="el-radio__label1" v-model="sign.type" label="B">{{ $t('sign_up.identity2') }}</el-radio>
          </el-col>
          <el-col :span="10">
            <el-radio class="el-radio__label1" v-model="sign.type" label="C">{{ $t('sign_up.identity3') }}</el-radio>
            <el-radio class="el-radio__label1" v-model="sign.type" label="D">{{ $t('sign_up.identity4') }}</el-radio>
          </el-col>
        </el-form-item>
<!--        <el-form-item :label="$t('sign_up.participate_Method')">-->
<!--          <el-radio v-model="sign.participateMethod" label="A">{{ $t('sign_up.participate_Method_online') }}</el-radio>-->
<!--          <el-radio v-model="sign.participateMethod" label="B">{{ $t('sign_up.participate_Method_offline') }}</el-radio>-->
<!--        </el-form-item>-->

        <br/>
        <div>{{$t('sign_up.SampleRegistration')}}</div>
        <span  :key="index">
          <el-image
              style="height: 148px;width: 148px;padding-right: 10px"
              :src="applicationExample"
              :preview-src-list="applicationExampleShow">
            </el-image>
        </span>
        <span v-for="(item,index) in images" :key="index">
           <el-image
               style="height: 148px;width: 148px;padding-right: 10px"
               :src="item"
               :preview-src-list="images">
            </el-image>
        </span>
        <br><br>
        <el-upload
            style="display: flex;
            justify-content: center;
            align-items: center;"
            list-type="picture-card"
            accept="image/jpeg,image/png,image/gif"
            :file-list="picFileList"
            :on-change="handleChangePic"
            :on-remove="handleRemovePic"
            :on-preview="handlePreviewPic"
            :auto-upload="false"
            action="">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">{{ $t('sign_up.upload_your_profile') }}</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" :alt="dialogImageAlt">
        </el-dialog>
      </el-form>
      <div slot="footer" class="dialog-footer" style="padding-top: 10px">
        <el-button @click="this.signUp()">{{ $t('sign_up.last_step') }}</el-button>
        <el-button type="primary" @click="commit()" :disabled="commitButtonDisable">{{ $t('sign_up.confirm') }}</el-button>
        <el-button type="primary" @click="invoice()">{{ $t('sign_up.invoice') }}</el-button>
      </div>
    </el-dialog>
  </div>

  <!--发票信息框-->
  <div>
    <el-dialog :title="$t('invoice.registration_form')" v-model="this.invoiceFlag">
      <div v-if="this.sign.comments!=null" style="font-weight: bold;font-size: 22px;margin-bottom: 10px">发票：</div>
        <el-form-item :label="$t('invoice.invoiceName')">
          <el-input v-model="sign.invoiceName" autocomplete="off"
                    :placeholder="this.$i18n.t('invoice.must_input')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('invoice.invoiceNumber')">
          <el-input v-model="sign.invoiceNumber" autocomplete="off"
                    :placeholder="this.$i18n.t('invoice.must_input')"></el-input>
        </el-form-item>

      <template v-if="zh">
        <el-form-item :label="$t('invoice.invoiceAddress')">
          <el-input v-model="sign.invoiceAddress" autocomplete="off"
                    :placeholder="this.$i18n.t('invoice.must_input')"></el-input>
        </el-form-item>
      </template>

      <template v-if="en">
        <el-form-item :label="$t('invoice.invoiceMail')">
          <el-input v-model="sign.invoiceMail" autocomplete="off"
                    :placeholder="this.$i18n.t('invoice.must_input')"></el-input>
        </el-form-item>
      </template>

      <div slot="footer" class="dialog-footer" style="padding-top: 10px" >
        <el-button type="primary" @click="invoiceCommit()">{{ $t('invoice.confirm') }}</el-button>
        <el-button type="primary" @click="invoiceCancel()">{{ $t('invoice.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>

  <!--  付费信息框-->
  <el-dialog v-model="dialogVisible2" :title=this.title>
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item :title=" $t('sign_up.pay.content1') " name="1">
        <div >{{ this.$t('sign_up.pay.content2') }}<a style="color: gray" href="https://www.paypal.com/paypalme/ECARGOSCHOOL">https://www.paypal.com/paypalme/ECARGOSCHOOL</a></div>

      </el-collapse-item>
      <el-collapse-item :title=" $t('sign_up.pay.content9') " name="3">
          <vue-qrcode :value="nativePay.codeUrl" :options="{ width: 200 }"></vue-qrcode>

      </el-collapse-item>
    </el-collapse>
    <br>
    <div style="padding-left:15px">{{$t('sign_up.SamplePayment')}}</div>
    <span  :key="index">
      <el-image
          style="height: 148px;width: 148px;padding-right: 10px"
          :src="payExample"
          :preview-src-list="payExampleShow">
      </el-image>
    </span>
    <span v-for="(item,index) in images2" :key="index">
      <el-image
          style="height: 148px;width: 148px;padding-right: 10px"
          :src="item"
          :preview-src-list="images2">
      </el-image>
    </span>
    <br><br>
    <el-upload
        style="display: flex;
            justify-content: center;
            align-items: center;"
        list-type="picture-card"
        accept="image/jpeg,image/png,image/gif"
        :file-list="picFileList2"
        :on-change="handleChangePic2"
        :on-remove="handleRemovePic"
        :on-preview="handlePreviewPic"
        :auto-upload="false"
        action="">
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip">{{ this.$t('sign_up.pay.upload_payment') }}</div>
    </el-upload>
    <el-button @click="this.back2()">{{ $t('sign_up.last_step') }}</el-button>
    <el-button type="primary" @click="submitCostPic()" :disabled="payButtonDisable">{{ $t('sign_up.pay.ensure_upload') }}</el-button>
  </el-dialog>
</template>

<script>
import * as CKEDITOR from "element-plus/es/components/message/src/instance";
const Base64 = require('js-base64').Base64
import Verify from "@/components/verifition/Verify";
import Show from  "@/views/index/Show"
import {ElMessage} from 'element-plus'

import ClassicEditor from "@/ckeditor/ckeditor";
import globalData from "@/util/globalData";

export default {
  components: {
    Verify,
    Show
  },
  data() {
    return {
      commitButtonDisable: false,//报名按钮是否显示
      payButtonDisable: false,//缴费按钮是否显示

      applicationExample:window.location.origin +'/api3/jitUpload/'+ '/pic/报名信息.png',
      applicationExampleShow:[window.location.origin +'/api3/jitUpload/'+ '/pic/报名信息.png'],
      payExample:window.location.origin +'/api3/jitUpload/'+ '/pic/支付信息.png',
      payExampleShow:[window.location.origin +'/api3/jitUpload/'+ '/pic/支付信息.png'],
      records: {},//test
      signUp_Next:false,
      signUp_User_Next:false,
      parentParam: '父页面数据',
      title1:this.$t('sign_up.pay.content1') ,
      activeNames: ['1'],
      nativePay:{},
      extraNativePay:{},
      codeText: 'https://blog.csdn.net/sleepwalker_1992',
      title: '',
      typeName: '',
      howMuchRMB: '',
      howMuchCAD: '',
      visible: false,
      sign1: false,
      user: [],
      proverVisible: false,
      sign: {
        // participateMethod:'A',
        questionOne: 1,
        questionTwo: 1,
        questionThree: 1,
        planId: '',
        userId: '',
        amount: '',
        currency: '',
        isReceipt: '',
        type: '',
        signState: '',
        firstName: '',
        lastName: '',
        gender: '',
        nationality: '',
        birthDate: '',
        affiliation: '',
        position: '',
        researchInterests: '',
        invoiceName:'',
        invoiceNumber:'',
        invoiceAddress:'',
        invoiceMail:'',
        contactAddress: '',
        telephone: '',
        email: '',
        comments:'',
        extraAmount: 0
      },
      // remi:{},
      picFileList: [],
      picFileList2: [],
      ServiceEvaluation: false,
      links: [],
      isCommit: 0,
      commitFlag: false,
      invoiceFlag: false,
      loginVisible: false,
      loginTitle: "登录",
      loginFlag: true,
      register: {
        userName: '',
        loginName: '',
        password1: '',
        password2: '',
        email: '',
        type: 'common',
      },
      loginForm: {
        loginName: '',
        password: '',
      },
      remember: false,//记住密码

      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
        toolbar: ['heading', '|', 'bold', 'italic', 'alignment', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'outdent', 'indent', '|', 'uploadImage', 'insertTable', '|', 'undo', 'redo'],
        simpleUpload: {
          uploadUrl: '/api3/config/fileInfo/uploadImg',
          withCredentials: false,
        }
      },
      zh:this.$i18n.locale.includes("z"),
      en:this.$i18n.locale.includes("e"),
      editorData: '',
      flag: 'Show',
      service: {
        url: '/fassessList',
        name: '评价服务',
        value: 'FAssessList',
        id: '.expert-title'
      },
      fileDownload: {
        name: '资料下载',
        value: 'FileDownload',
        id: '.fileDownload'
      },
      tab: [
        {
          url: '/',
          name: 'menus.home',
          value: 'Show'
        },
        {
          url: '/callForPapers',
          name: 'CallForPapers',
          value: 'callForPapers'
        },
        {
          name: 'menus.IEEESMC',
          value: 'menus.IEEESMC',
        },
      ],
      picIndex: '',//富文本编辑器id
      imageUrl: [],//图片回显路径
      dialogImageUrl: '',// 图片预览地址
      dialogImageAlt: '',// 图片预览提示文字
      dialogVisible: false,// 是否显示预览
      dialogVisible2: false,
      dialogVisible3: false,//登录界面
      images: [],
      images2: []

    }
  },
  watch: {
    $route(to, from) {
      console.log('tooooooooooooooooo', to)
      console.log('frommmmmmmmmmmmmmm', from)
      console.log('tab', this.tab)
      for (let item of this.tab) {
        if (to.name === item.value) {
          document.getElementById(to.name).style.background = "#1f3880";
        }
        if (from.name === item.value) {
          document.getElementById(from.name).style.background = "#1f3880";
        }
      }
    },
  },
  created() {
    this.getrecords()
    window.localStorage.setItem("lang", this.$i18n.locale);
    console.log("========================"+this.$i18n.locale)
    this.getPlanIdAndSign();
    if (this.$cookies.get('userId')) {
      this.isCommit = 1
      globalData.isCommit = 1
    } else {
      this.isCommit = 0
      globalData.isCommit = 0
    }
    //在页面加载时从cookie获取登录信息
    let loginName = this.$cookies.get("username")
    // 如果存在赋值给表单，并且将记住密码勾选
    if (loginName) {
      let password = Base64.decode(this.$cookies.get("password"))
      this.loginForm.loginName = loginName
      this.loginForm.password = password
      this.remember = true
    }
  },

  mounted() {
    for (let item of this.tab) {
      if (this.$route.name === item.value) {
        document.getElementById(this.$route.name).style.background = "#1f3880";
        return
      }
    }
    // loginFlag: {
    //   handler(newVal, oldVal)
    //   {
    //     console.log("oldVal",oldVal)
    //     console.log("newVal",newVal)
    //     if (newVal) {
    //       this.$nextTick(() => {
    //         this.$refs.psswordLogin.style.borderBottom = "2px solid #1269FF";
    //         this.$refs.register.style.border = "none";
    //       })
    //     } else {
    //       this.$nextTick(() => {
    //         this.$refs.register.style.borderBottom = "2px solid #1269FF";
    //         this.$refs.psswordLogin.style.borderBottom = "none";
    //       })
    //     }
    //   }
    //   immediate: true
    // }
  },

  beforeDestroy() {
  },

  methods: {
    extraPay(){
      let nativeParam = {
        total: this.sign.extraAmount*100,
        currency: "CNY" //货币类型【CNY：人民币，境内商户号仅支持人民币。】
      }
      // native下单请求发送
      this.$request.post("/sign/native",nativeParam).then(nativeRes=>{
        this.extraNativePay = nativeRes.obj
      })
    },

    //点击实现图片放大：
    showImagePreview(){
      const image = new Image();
      image.src = window.location.origin +'/api3/jitUpload/'+ '/pic/报名信息.png';
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = this.imageUrl;
        previewImage.style.maxWidth = '80%';
        previewImage.style.maxHeight = '80%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    },
    getrecords() {
      this.records = this.$route.params.records
      // 进行值存储判断他是否为undefined
      if (this.records === undefined) {
        this.records = JSON.parse(sessionStorage.getItem('records'))
      } else {
        sessionStorage.setItem('records',JSON.stringify(this.$route.params.records))
      }
    },
    //点击“立即报名，滑动到页面顶端并且打开报名弹窗”
    sonChangeSign1(){
      this.sign1=true
    },
    beforeRouteLeave(to,from,next){
      to.meta.keepAlive = true
      next(0)
    },
    //三个缴费方式
    handleChange(val) {
      console.log(val);
    },
    //返回
    back2() {
      this.dialogVisible2 = false
      this.commitFlag = true
    },

    submitCostPic() {
      let picFormData = new FormData()
      this.picFileList2.forEach(
          (val, index) => {
            // piclist.push(val.raw)
            picFormData.append("fileList", val.raw)
          }
      )
      picFormData.append("type", "j")
      picFormData.append("userId", this.user.id)
      // picFormData.append("sign",JSON.stringify(data))
      // console.log(picFormData.get('sign'))
      let url2 = '/sign/insertImg2';
      this.payButtonDisable = true;//确定按钮无法点击
      this.$request.post(url2, picFormData).then((data) => {

      })
      this.dialogVisible2=false;
      this.payButtonDisable = false;//确定按钮可以点击
      this.$message({
        message: this.$t('sign_up.upload_success'),
        type: 'success'
      });
    },
    getPlanIdAndSign() {
      return new Promise((resolve, reject) => {
        let url = '/sign/getPlanId'
        this.$request.post(url).then((data) => {
          this.sign.planId = data.obj;
          console.log('planId', data.obj)
          let url = '/sign/getUser';
          this.$request.post(url).then((data) => {
            this.user = data.obj
            console.log('this.uesr', data.obj)
            console.log("this.signUp_Next",this.signUp_Next)
            if ((this.user!=null||this.user=='')&&(this.isManager==null||this.isManager=='')){
              this.sign1=true
            }
            // isManager  isBusiness  here
            let url = '/sign/getSignByUserId'
            if(this.user!=null){
              let data2 = {
                userId: this.user.id
              }
              this.$request.post(url, data2).then(res => {
                let data = res.obj
                console.log('dataa', data)
                if (data == null) {
                  this.sign.questionOne = ''
                  this.sign.questionTwo = ''
                  this.sign.questionThree = ''
                  this.sign.firstName = ''
                  this.sign.lastName = ''
                  this.sign.gender = ''
                  this.sign.nationality = ''
                  this.sign.birthDate = ''
                  this.sign.affiliation = ''
                  this.sign.position = ''
                  this.sign.researchInterests = ''
                  this.sign.contactAddress = ''
                  this.sign.telephone = ''
                  this.sign.email = ''
                  this.sign.comments = ''
                  this.sign.type = ''
                  this.picFileList = []
                  this.images = []
                  this.images2 = []
                } else {
                  this.sign.questionOne = data.questionOne
                  this.sign.questionTwo = data.questionTwo
                  this.sign.questionThree = data.questionThree
                  this.sign.firstName = data.firstName
                  this.sign.lastName = data.lastName
                  this.sign.gender = data.gender
                  this.sign.nationality = data.nationality
                  this.sign.birthDate = data.birthDate
                  this.sign.affiliation = data.affiliation
                  this.sign.position = data.position
                  this.sign.researchInterests = data.researchInterests
                  this.sign.contactAddress = data.contactAddress
                  this.sign.telephone = data.telephone
                  this.sign.email = data.email
                  this.sign.type = data.type
                  this.sign.comments = data.comments
                  // if (data.type == 'A') {
                  //   this.typeName = this.$t('sign_up.identity1')
                  //   this.howMuchRMB = 0
                  // } else if (data.type == 'B') {
                  //   this.typeName = this.$t('sign_up.identity2')
                  //   this.howMuchRMB = 0
                  // } else if (data.type == 'C') {
                  //   this.typeName = this.$t('sign_up.identity3')
                  //   this.howMuchRMB = 35
                  // } else if (data.type == 'D') {
                  //   this.typeName = this.$t('sign_up.identity4')
                  //   this.howMuchRMB = 70
                  // }
                  //付费金额
                  // this.title = this.$t('sign_up.pay.title1') + this.typeName + this.$t('sign_up.pay.title2') + this.howMuchRMB + this.$t('sign_up.pay.title3');
                  let url = '/sign/getSignPictures'
                  this.$request.post(url).then((data) => {
                    console.log('dataaaaaaaaa', data)
                    // 原先的图片获取
                    this.images = data.obj
                    console.log(this.images)
                    // debugger
                    for (let i = 0; i < this.images.length; i++) {
                      this.images[i]=window.location.origin +'/api3/'+ this.images[i];
                      // this.images.length-=1
                      console.log(this.images[i]);
                      // debugger
                    };
                    let url3 = '/sign/getCostPictures'
                    //原来获取报名信息图片的方法  //获取支付信息
                    this.$request.post(url3).then((data) => {
                      this.images2 = data.obj
                      for (let i = 0; i < this.images2.length; i++) {
                        this.images2[i] = window.location.origin + '/api3/' + this.images2[i];
                        console.log(this.images2[i])
                      }
                      resolve();
                    })
                  })
                }
              })
            }
          })
        })
      })
    },

    //确认信息
    invoiceCommit() {
      var nowDate = new Date();
      let m = nowDate.getMonth()+1
      let today = nowDate.getFullYear() +'-'+ m +"-"+ nowDate.getDate()+' '+ nowDate.getHours() +':'+ nowDate.getMinutes()
      // date1 = new Date(date1).getTime();
      today = new Date(today).getTime();
      if (this.sign.invoiceName == '' || this.sign.invoiceNumber == '' || (this.sign.invoiceAddress == ''&&this.sign.invoiceMail == '') ) {
        alert("请填写完整")
      }
      else {
        this.invoiceFlag = false
        this.sign.userId = this.user.id
        let data = {
          name: this.sign.invoiceName,
          code: this.sign.invoiceNumber,
          address: this.sign.invoiceAddress,
          signId: this.sign.userId,
          mail: this.sign.invoiceMail
          // type: this.$i18n.locale
        }
        console.log(data)
        let url = '/Invoice/insertInvoice';
        this.$request.post(url, data).then((data) => {
          console.log("========================test")
          this.$message({
            message: '登记报销成功',
            type: 'success'
          });
        })
      }
    },

    /**
     *   通过身份、线上线下来确认费用
     */
    confirmExpenses(){
      var nowDate = new Date();
      let m = nowDate.getMonth()+1
      let today = nowDate.getFullYear() +'-'+ m +"-"+ nowDate.getDate()+' '+ nowDate.getHours() +':'+ nowDate.getMinutes()
      let date1='2025-5-21 00:00'
      date1 = new Date(date1).getTime();
      today = new Date(today).getTime();
        if (today<date1){
          //身份信息
          if (this.sign.type == 'A') {
            this.typeName = this.$t('sign_up.identity1')
            this.howMuchRMB = 3000
            this.howMuchCAD = 600
          } else if (this.sign.type == 'B') {
            this.typeName = this.$t('sign_up.identity2')
            this.howMuchRMB = 3500
            this.howMuchCAD = 700
          } else if (this.sign.type == 'C') {
            this.typeName = this.$t('sign_up.identity3')
            this.howMuchRMB = 1500
            this.howMuchCAD = 300
          } else if (this.sign.type == 'D') {
            this.typeName = this.$t('sign_up.identity4')
            this.howMuchRMB = 4000
            this.howMuchCAD = 800
          }
        }
        else if (today>=date1){
          //身份信息
          if (this.sign.type == 'A') {
            this.typeName = this.$t('sign_up.identity1')
            this.howMuchRMB = 3500
            this.howMuchCAD = 650
          } else if (this.sign.type == 'B') {
            this.typeName = this.$t('sign_up.identity2')
            this.howMuchRMB = 4000
            this.howMuchCAD = 750
          } else if (this.sign.type == 'C') {
            this.typeName = this.$t('sign_up.identity3')
            this.howMuchRMB = 2000
            this.howMuchCAD = 400
          } else if (this.sign.type == 'D') {
            this.typeName = this.$t('sign_up.identity4')
            this.howMuchRMB = 4500
            this.howMuchCAD = 850
          }
      }else {
        alert('费用计算失败，请联系管理员')
      }
      this.title = this.$t('sign_up.pay.title1') + '\xa0' + this.typeName + this.$t('sign_up.pay.title2') + '\xa0' + this.howMuchRMB + '\xa0' + this.$t('sign_up.pay.title3')
          + this.howMuchCAD + '\xa0' + this.$t('sign_up.pay.title4')
    },


    //确认信息
    commit() {
      //通过身份、线上线下来确认费用
      this.confirmExpenses();
      if (this.sign.firstName == '' || this.sign.lastName == '' || this.sign.type == '' ||
          this.sign.gender == '' || this.sign.nationality == '' || this.sign.birthDate == '' || this.sign.affiliation == '' ||
          this.sign.position == '' || this.sign.researchInterests == '' || this.sign.contactAddress == '' || this.sign.telephone == '' || this.sign.email == '') {
        alert("请填写完整")
      } else if (this.picFileList.length == 0 && this.images.length == 0)
        alert(this.$i18n.t('sign_up.upload_pic'))

      else {
        this.commitFlag = false
        this.sign.userId = this.user.id
        let data = {
          planId: this.planId,
          userId: this.sign.userId,
          type: this.sign.type,
          signState: 'A',
          // type2:this.sign.type2,
          questionOne: this.sign.questionOne,
          questionTwo: this.sign.questionTwo,
          questionThree: this.sign.questionThree,
          firstName: this.sign.firstName,
          lastName: this.sign.lastName,
          gender: this.sign.gender,
          nationality: this.sign.nationality,
          birthDate: this.sign.birthDate,
          affiliation: this.sign.affiliation,
          position: this.sign.position,
          researchInterests: this.sign.researchInterests,
          contactAddress: this.sign.contactAddress,
          telephone: this.sign.telephone,
          email: this.sign.email,
          comments: this.sign.comments,
          participateMethod:this.sign.participateMethod
        }
        let picFormData = new FormData()
        this.picFileList.forEach(
            (val, index) => {
              picFormData.append("fileList", val.raw)
            }
        )
        picFormData.append("type", "j")
        picFormData.append("userId", this.user.id)
        let url = '/sign/insertSign';
        this.commitButtonDisable = true;//使得按钮无法点击
        this.$request.post(url, data).then((data) => {
          let url2 = '/sign/insertImg';
          this.$request.post(url2, picFormData).then((data) => {})
          this.$message({
            message: '登记成功',
            type: 'success'
          });
          let nativeParam = {
            total: this.howMuchRMB*100,
            currency: "CNY" //货币类型【CNY：人民币，境内商户号仅支持人民币。】
          }
          console.log("post native",nativeParam)
          // native下单请求发送
          this.$request.post("/sign/native",nativeParam).then(nativeRes=>{
            console.log("/sign/native",nativeRes)
            this.nativePay = nativeRes.obj
          })
          this.commitButtonDisable = false;//使得报名按钮可以点击
          //打开付费页面
          this.dialogVisible2 = true;
          // console.log(this.dialogVisible2)
        })
      }
    },
    signUp() {
      this.commitFlag = false;
      this.sign1 = true;
      if ((this.sign.questionOne===''||this.sign.questionOne===null)||
          (this.sign.questionTwo===''||this.sign.questionTwo===null)||
          (this.sign.questionThree===''||this.sign.questionThree===null)){
        this.sign.questionOne = 1
        this.sign.questionTwo = 1
        this.sign.questionThree = 1
      }
      else {}
    },
    invoiceCancel(){
      this.invoiceFlag = false;
    },
    getUser() {
      if (this.user == null) {
        this.dialogVisible3=true
        this.$msg.warning(this.$t('login.login_register_frst'))
      } else if (this.sign.questionOne === null || this.sign.questionOne === '') {
        alert(this.$i18n.t('login.choose_q1'))
      } else if (this.sign.questionTwo === null || this.sign.questionTwo === '') {
        alert(this.$i18n.t('login.choose_q2'))
      }else if (this.sign.questionThree === null || this.sign.questionThree === '') {
        alert(this.$i18n.t('login.choose_q3'))
      }  else this.commitFlag = true
    },
    /**
     * 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
     * @param pic 当前图片
     * @param picList 图片列表
     */
    handleChangePic(pic, picList) {
      this.picFileList = picList
      console.log('11', picList)
    },

    /**
     * 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
     * @param pic 当前图片
     * @param picList 图片列表
     */
    handleChangePic2(pic, picList) {
      this.picFileList2 = picList
      console.log('11', picList)
    },
    /**
     * 文件列表移除文件时的钩子
     * @param pic 移除的图片
     * @param picList 图片列表
     */
    handleRemovePic(file) {
      // 处理移除图片的操作
      // handleRemove(file) {
      // 1.获取将要删除图片的临时路径
      const filePath = file.response.data.tmp_path;
      // 2.从pics数组中，找到图片对应的索引值
      const i = this.addForm.pics.findIndex((x) => x.pic === filePath);
      // 3.调用splice方法，移除图片信息/
      this.addForm.pics.splice(i, 1);
      // },
    },

    /**
     * 点击文件列表中已上传的文件时的钩子
     * @param pic 当前图片
     */
    handlePreviewPic(pic) {
      this.dialogImageUrl = pic.url;
      this.dialogImageAlt = pic.name;
      this.dialogVisible = true;
    },
    /**
     * 图片超出个数限制
     */
    handleExceedPicLimit() {
      alert('The maximum number of pictures has been exceeded');
    },

    logout() {
      this.$request.post("/jwtUser/logout").then(res => {
        if (res.obj == "注销成功") {
          this.$store.commit("logout");
          this.$router.push('/');
          this.$msg.success(this.$i18n.t('login.login_out'))
          window.location.reload();
        } else {
          this.$msg({
            message: res.obj,
            type: 'warning'
          });
        }
      });
      this.isCommit = 0
      globalData.isCommit = 0
    },
    open1() {
      this.getUser()
      if(this.user==null||this.user==''){
        this.signUp_Next=true
        console.log("this.signUp_Next",this.signUp_Next)
        // debugger
      }
    },
    invoice(){
      this.invoiceFlag=true
    },
    checkSign1(){
      console.log("this.signUp_Next",this.signUp_Next,this.user)
      if (this.signUp_Next==true&&this.user=="isBusiness"){
        this.sign1=true

      }
    },
    showDatePicker() {
      if (this.$refs.pickers) {
        this.$nextTick(() => {
          this.$refs.pickers.showCurrentDate()
        })
      }
    },
    //获取友情链接
    getLinks() {
      this.$request.post('/FileUpload/getUrl',).then(data => {
        console.log(data)
        this.links = data.obj;
        console.log(this.links)
      })
    },
    //跳转页面
    jump(url) {
      this.$router.push(url);
    },

    jumpToBBS() {
      let routeData = this.$router.resolve({name: 'BBS'});
      window.open(routeData.href, '_blank');
    },
    jumpToFirstSession(){
      window.open('http://www.e-cargoschool.com/1', '_blank');
    },
    jumpToSecondSession(){
      window.open('http://www.e-cargoschool.com/2', '_blank');
    },

    exchangeLanguage(value) {
      if (value === 'English') {
        this.$i18n.locale = 'en';
        localStorage.setItem("lang", "en");
      } else if (value === '中文') {
        this.$i18n.locale = 'zh';
        localStorage.setItem("lang", "zh");
      }
      console.log("this.$i18n.locale:", this.$i18n.locale)
      window.location.reload();
    },

    verifySuccess(params) {
      console.log('二次验证参数', params);
      this.login();
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    },

    /***
     * 登录按钮
     */
    loginVerify() {
      if (this.loginForm.loginName === '' || this.loginForm.password === '') {
        this.$message({
          message: this.$t('login.no_null'),
          type: 'warning'
        });
        return
      }
      this.dialogVisible3 = false
      this.$refs.verify.show()
    },
    login() {
      let data = {
        username: this.loginForm.loginName,
        password: this.loginForm.password,
      }
      let url = '/jwtUser/login'
      this.$request.post(url, data).then((res) => {
        if (res.msg == "用户名或密码错误") {
          ElMessage({
            message: this.$i18n.t('login.login_error'),
            type: 'warning',
          })
          return;
        } else if (res.obj.info == "登录成功") {
          let loginInfo = {
            userId: res.obj.userId,
            username: this.loginForm.loginName,
            isManager: res.obj.isManager,
            isBusiness: res.obj.isManager,
            token: res.obj.token,
            time: res.obj.time
          }
          console.log("loginInfo", loginInfo.isManager)
          console.log("loginInfo", loginInfo.isBusiness)
          this.$store.commit("login", loginInfo);
          this.$cookies.set("isManager", loginInfo.isManager)
          if (this.remember) {
            this.$cookies.set("username", this.loginForm.loginName, 3 * 24 * 60 * 60);
            this.$cookies.set("password", Base64.encode(this.loginForm.password), 3 * 24 * 60 * 60);

          }
          if (loginInfo.isManager == 1) {
            this.$router.push("/Home")
            globalData.isCommit = 1

          } else {
            globalData.isCommit = 1
            this.$router.push({
              path: "/",
              // 或path: '/×××/×××',query:{}
              params: {
                records:this.signUp_Next
              }
            })
          }
          this.$msg.success(this.$i18n.t('login.login_success'))
          // debugger
          if (loginInfo.isManager != 1){
            location.reload()
          }
          this.getPlanIdAndSign()

          this.isCommit = 1

        } else {
          ElMessage({
            message: res.obj.info,
            type: 'warning',
          })
          return;
        }
      })
    },
    mregister() {
      if (this.register.loginName == '') {
        this.$msg.warning(this.$t('login.phone_p'))
      } else if (this.register.password1 == '' || this.register.password2 == '') {
        this.$msg.warning(this.$t('login.password_p'))
      } else if (this.register.password1 == this.register.password2) {
        let data = {
          username: this.register.loginName,
          password: this.register.password1,
          phone: this.register.loginName,
          email: this.register.email,
          isBusiness: 0
        }
        let url = '/jwtUser/register'
        this.$request.post(url, data).then((res) => {
          if (res.obj == "用户已存在") {
            ElMessage({
              message: this.$t('login.user_exist'),
              type: 'warning',
            })
            return;
          } else if (res.obj == "手机号已被绑定") {
            this.$message({
              message: this.$t('login.phone_exist'),
              type: 'warning'
            });
          } else if (res.obj == "注册失败") {
            ElMessage({
              message: this.$t('login.register_error'),
              type: 'warning',
            })
            return;
          } else {
            ElMessage({
              message: this.$t('login.register_success'),
              type: 'success',
            })
            this.loginFlag = !this.loginFlag;
            // this.$router.push("/")
            return;
          }
        })
      } else {
        this.$msg.warning(this.$t('login.password_p_2'))
      }
    },

    click() {
      this.aaa = true
    },
    admit() {
      // console.log("这是我要的数据", this.editorData)
    },


    aClick(item) {
      console.log("item",item)
     if(item.value=="menus.IEEESMC"){
        let routeUrl="https://www.ieee.org/membership/join/index.html?WT.mc_id=hc_join"
       window.open(routeUrl, '_blank'); //在新窗口显示目标网页
     }
     else if (item.value=="callForPapers"){
       let routeUrl="CalForPapers.pdf"
       window.open(routeUrl, '_blank'); //在新窗口显示目标网页
     }
     else  this.$router.push(item.url).then(()=>{
       window.location.reload();
       });
    },
  },
};

</script>
<style lang="less">

.title_box {
  margin: 20px 50px 20px 0;
  border-bottom: 5px solid #F4F4F4;
  height: 30px;

  .title {
    float: left;
    font-size: 25px;
    font-weight: bold;
    width: 150px;
    height: 30px;
    text-align: center;
    border-bottom: 5px solid #698fe5;
  }

  .title:hover {
    cursor: pointer;
  }
}

.login {
  overflow-y: scroll;
  margin-left: 7px;
  width: 380px;
  height: 300px;
  //width: 350px;
  //height: 220px;
  background: white;
  margin-bottom: 7px;
  //border-radius: 20px;
  box-shadow: 0px 0px 0px 20px #1f3880;


  .el-input__prefix {
    color: #78AAFF;
  }

  .el-dialog__body {
    padding: 0px;
  }

  .login_tab {
    height: 60px;
  }

  .login_tab_item1 {
    float: left;
    margin-top: 30px;
    margin-left: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item2 {
    display: inline-block;
    float: right;
    margin-top: 30px;
    margin-right: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item1:hover {
    cursor: pointer;
  }

  .login_tab_item2:hover {
    cursor: pointer;
  }

  .el-form-item__content {
    margin-left: 0;
  }

  .remember {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    //margin-left: 40px;

    .el-checkbox {
      color: #CCCCCC;
    }
  }

  .login_button {
    width: 200px;
    //float:right;
    background: #ffffff;
    margin-left: 100px;
    margin-top: 20px;
    box-shadow: 0px 20px 10px -10px #CBDEFF;
  }
}

.login2 {
  //overflow-y: scroll;
  margin-left: 0px;
  //width: 380px;
  //height: 300px;
  width: 450px;
  height: 300px;
  background: white;
  margin-bottom: 0px;
  //border-radius: 20px;
  box-shadow: 0px 0px 0px 15px #1f3880;

  //.el-input__inner {
  //  border: 2px solid #78AAFF;
  //}

  .el-input__prefix {
    color: #78AAFF;
  }

  .login_tab {
    height: 60px;
  }

  .login_tab_item1 {
    float: left;
    margin-top: 30px;
    margin-left: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item2 {
    float: right;
    margin-top: 30px;
    margin-right: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item1:hover {
    cursor: pointer;
  }

  .login_tab_item2:hover {
    cursor: pointer;
  }

  .el-form-item__content {
    margin-left: 0;
  }

  .remember {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    //margin-left: 40px;

    .el-checkbox {
      color: #CCCCCC;
    }
  }

  .login_button {
    width: 200px;
    //float:right;
    background: #1f3880;
    margin-left: 100px;
    margin-top: 20px;
    box-shadow: 0px 20px 10px -10px #CBDEFF;
  }
}

.index {
  height: 100%;
  width: 100%;
  overflow-y: scroll;

  .a:link {
    text-decoration: none;
    color: #929292;
  }

  .a:visited {
    color: #929292;
  }

  .header {
    //height: 81pt;
    width: 100%;
    height: 100px;
    //background: #890c0c;
    //background-image: #F5F5F5;
    left: 0;
    //background: url(../../assets/backgroundIcon2.png) no-repeat right center;

    .elpopover {
      margin-top: 30px;
      width: 115px;
      height: 50px;
      float: right;

      .login_style {
        margin-right: 100px;
        margin-top: 100px;
      }
    }

    //首页顶部栏的背景色
    .logo_box {
      width: 100%;
      height: 100%;
      margin: auto;
      background: #1462ad;
      //background: url(../../assets/backgroundIcon2.png) no-repeat right center;
      .logo1 {
        float: left;
        width: 15%;
        margin-left: 0%;
        margin-bottom: 0;
        width: auto;
        height: auto;
        max-width: 180px;
        max-height: 160px;
        //background: #3A62FE;
        img {
          margin-top: 14%;
          width: 100%;
          height: 100%;
        }
      }
      .logo2 {
        //background: #0e5c31;
        //background: #2AB68F;
        //width: 600px;
        //padding: 0px 0 0 10%;
        //float: left;
        float:right;
        width: 15%;
        margin-left: 5px;
        margin-bottom: 0;
        width: auto;
        height: auto;
        max-width: 180px;
        max-height: 160px;


        img {
          margin-top: 25%;
          width: 100%;
          height: 100%;


        }
      }

      .logo_title {
        float: left;
        width: 45%;
        height:70%;
        //margin-left: 10%;
        //background: #0e5c31;
        font-size: 20px;
        color: #ffffff;
        margin-top: 1%;
        margin-left: 2%;
        font-style: italic;
        //background: #0e5c31;
      }

      .logo_word {
        line-height: 30pt;
        color: #d92fe0;
        font-weight: 700;
        line-height: 30pt;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .tab-covered {
    // display: inline-block;
    width: 100%;
    height: 50px;
    background: #1f3880;

    .tab_list {
      margin: 0 auto;
      width: 85%;
      height: 50px;

      .tab_item {
        float: left;
        margin-left: 5px;
        padding-left: 20px;
        padding-right: 20px;
        height: 50px;
        line-height: 50px;
        color: white;
        font-size: 18px;
        font-weight: bold;
      }

      .tab_item:hover {
        cursor: pointer;
      }
    }
  }

  //.dropdown-style {
  //  color: red;
  //  font-size: 18px;
  //  font-weight: bold;
  //  padding-left: 20%;
  //}

  .content_index {
    display: grid;
    margin: auto;
    min-height: 100%;
    width: 100%;
    //background: black;
    //background: linear-gradient(137deg, #83e4ee 0%, #73bb02 100%);
    //background: url(../../assets/background.jpeg);
    //.login-bg {
    //  width: 100%;
    //  height: 100%;
    //  background: white;
    //  position: absolute;
    //}
    .lizi {
      width: 100%;
      height: 100%;
      position: absolute;

      #particles-js {
        width: 100%;
        height: 100%;
        //position: absolute;
        //background: #3A62FE;
      }
    }

    .router_view {
      width: 80%;
      margin: auto;
      position: relative;
    }

  }

  .bottom_index {
    margin-top: 50px;
    color: black;
    padding-top: 30PX;
    height: 60px;
    text-align: center;
    background: #F5F5F5;

    .FriendLink {
      text-align: center;
      height: 40px;
      //background-color: red;
      ul {
        height: 100%;

        li {
          display: inline-block;
          padding: 3px;
        }
      }
    }

    .bottom {
      height: 100%;
      margin-top: 20px;
      //margin-bottom: 20px;
      //background: #970e0e ;
      font-size: 14px;
      font-weight: bold;
      color: #929292;
      line-height: 20px;
    }

  }

}

.el-form-item__label {
  display: inline-block;
  width: 142px;
  text-align: left;
  font-weight: bold;



}
.el-form-item__label::before {
  content: '* ';
  color: red;
}

.el-radio__label1 {
  //display: inline-block;
  //width: 120px;
  //text-align: left;
  display: inline-block;
  width: 200px;
  text-align: left;
  //font-weight: bold;
}

//去除滚动条
//::-webkit-scrollbar {
//  width: 0 !important;
//}
.login_tab {
  height: 60px;
  font-size: 20px;

  .login_tab_item1 {
    float: left;
    margin-top: 30px;
    margin-left: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item2 {
    display: inline-block;
    float: right;
    margin-top: 30px;
    margin-right: 80px;
    padding-bottom: 20px;
  }

  .login_tab_item1:hover {
    cursor: pointer;
  }

  .login_tab_item2:hover {
    cursor: pointer;
  }

  .el-input .el-input__inner {
    font-size: 14px;
    font-weight: bolder;
    padding: 0 4px;
  }
}


</style>
